import React from 'react';
import { CountryDataForm } from '../../../../app/models/Country';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';

interface Props {
    countryDataForm: CountryDataForm;
    setCountryDataForm: (country: CountryDataForm) => void;
    errorFields?: any;
}

const CountryForm = ({ countryDataForm, setCountryDataForm, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove } = useHandleErrorFields();

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setCountryDataForm({ ...countryDataForm, [name]: value });
        onFocusRemove(name);
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre <span className="text-danger">*</span></label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="name"
                        className={`form-control ${fieldHasError('name')}`}
                        value={countryDataForm.name ?? ''}
                        onChange={handleInput}
                        placeholder="Nombre del país"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('name')}</div>
                </div>
            </div>

            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Prefijo Telefónico</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        name="phone_prefix"
                        className={`form-control ${fieldHasError('phone_prefix')}`}
                        value={countryDataForm.phone_prefix ?? ''}
                        onChange={handleInput}
                        placeholder="Ej: +56"
                    />
                    <div className="invalid-feedback">{fieldErrorMessage('phone_prefix')}</div>
                </div>
            </div>
        </>
    );
};

export default CountryForm;
